module.exports = __webpack_public_path__ + "band_11_daughter.76dfd98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_11_daughter.png
// module id = Tu8D
// module chunks = 0